import React, { useEffect, useRef } from "react";
import { FaSignOutAlt, FaTimes, FaUserAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { adminPortalLogin } from "../features/urlConst/domainUrl";
// Redux
import { logout, resetAuth } from "../features/auth/authSlice";
import { resetSetting } from "../features/setting/settingSlice";
import { persistor } from "../app/store";
// Util
import Modal from "react-modal";
import { useState } from "react";
import { Link } from "react-router-dom";
import { resetOrder, resetSearchSort } from "../features/order/orderSlice";
import { resetUsers } from "../features/user/userSlice";
import { resetProfile } from "../features/profile/profileSlice";

const Navbar = () => {
  const { token, user_info } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const navigateToLoginPortal = () => {
    window.location.href = adminPortalLogin + "?token=" + token;
  };

  Modal.setAppElement("#root");
  const [modalLogoutIsOpen, setModalLogoutIsOpen] = useState(false);
  const onLogoutHandler = (e) => {
    e.preventDefault();
    dispatch(logout(token))
      .unwrap()
      .then((res) => {
        if (res && res.data.result === "success") {
          dispatch(resetSearchSort());
          dispatch(resetOrder());
          dispatch(resetUsers());
          dispatch(resetProfile());
          dispatch(resetSetting());
          dispatch(resetAuth());
          // remove persisted data from local storage
          persistor.purge();
          navigateToLoginPortal();
          toast.success("Logged out successfully");
        }
      })
      .catch((error) => {
        if (error && error.response.data.description === "expired token") {
          dispatch(resetSearchSort());
          dispatch(resetOrder());
          dispatch(resetUsers());
          dispatch(resetProfile());
          dispatch(resetSetting());
          dispatch(resetAuth());
          // remove persisted data from local storage
          persistor.purge();
          toast.error("Login session expired");
        }
      });
  };

  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const menuRef = useRef();
  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setUserDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <nav className="w-full h-full flex items-center min-h-[50px] px-2 md:px-4 shadow-sm shadow-blue-900">
      <div className="w-full flex justify-between items-center">
        <div onClick={navigateToLoginPortal}>
          <h1 className="font-semibold">Ato Cloud</h1>
        </div>
        <div className="flex items-start gap-4">
          {/* Profile */}
          {/* <Link
            to='my-page'
            className='flex justify-between items-center gap-[2px] cursor-pointer text-md'
          >
            <span className='text-md'>
              <FaUserAlt />
            </span>{' '}
            <p>{user_info?.name}</p>
          </Link> */}
          {/* End Profile */}
          {/* Profile */}
          <div
            ref={menuRef}
            className="relative flex justify-between items-center gap-[2px]"
          >
            <div
              onClick={() => setUserDropdownOpen((prev) => !prev)}
              className="flex justify-between items-center gap-[2px] cursor-pointer"
            >
              <span className="text-md">
                <FaUserAlt />
              </span>{" "}
              {/* <p>{user_info?.name}</p> */}
              <p className="px-[2px]">{user_info?.user_name}</p>
            </div>
            {/* User Dropdown */}
            {userDropdownOpen && (
              <div className="absolute top-full right-0 min-w-[160px] mt-2 bg-gray-800 text-white flex flex-col justify-start border-[1px] border-gray-300 rounded-[12px] text-sm">
                <Link
                  to="/profile"
                  className="flex justify-start items-center gap-2 p-2 hover:bg-blue-600 mt-2"
                  onClick={() => setUserDropdownOpen(false)}
                >
                  マイアカウント
                </Link>
                <p className="w-full h-[1px] bg-gray-300 my-2"></p>
                <div
                  onClick={() => {
                    setUserDropdownOpen(false);
                    setModalLogoutIsOpen(true);
                  }}
                  className="w-full flex justify-start items-center gap-2 p-2 hover:bg-blue-600 mb-2 cursor-pointer"
                >
                  <span className="mt-[2px]">
                    <FaSignOutAlt />
                  </span>{" "}
                  {/* <p>ログアウト</p> */}
                  <p>ログアウト</p>
                </div>
              </div>
            )}
            {/* End User Dropdown */}
          </div>
          {/* End Profile */}

          {/* Logout */}
          {/* <div
            onClick={(e) => setModalLogoutIsOpen(true)}
            className='flex justify-between items-center gap-[2px] cursor-pointer text-md'
          >
            <span className='text-md'>
              <FaSignOutAlt />
            </span>{' '}
            <p>ログアウト</p>
          </div> */}
          {/* End Logout */}
        </div>
      </div>

      {/* Modal Logout */}
      <Modal
        isOpen={modalLogoutIsOpen}
        onRequestClose={() => setModalLogoutIsOpen(false)}
        style={customStyles}
        contentLabel="Logout"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={() => setModalLogoutIsOpen(false)}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
          ログアウト ?
        </h2>
        <form onSubmit={onLogoutHandler} className="p-2 flex flex-col">
          <div className="flex justify-end gap-2">
            <button
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="submit"
            >
              確定する
            </button>

            <button
              onClick={() => setModalLogoutIsOpen(false)}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              キャンセル
            </button>
          </div>
        </form>
      </Modal>
      {/* End Modal Logout */}
    </nav>
  );
};

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    zIndex: 1000,
  },
  content: {
    maxHeight: "80vh",
    width: "80%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    position: "relative",
    border: "1px solid black",
    background: "#fff",
  },
};

export default Navbar;
